import { render } from "./EmailVerificationView.vue?vue&type=template&id=6da2e012&scoped=true"
import script from "./EmailVerificationView.vue?vue&type=script&lang=js"
export * from "./EmailVerificationView.vue?vue&type=script&lang=js"

import "./EmailVerificationView.vue?vue&type=style&index=0&id=6da2e012&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da2e012"]])

export default __exports__